import { useState } from 'react';

const faqData = [
  {
    q: '8090影院真的完全免费吗？',
    a: '是的，8090影院所有电视剧资源均为免费在线观看，无需注册、无需会员、无需付费。我们通过广告收入维持平台运营，坚决不向用户收取任何费用，让每一位追剧爱好者都能零门槛享受高清追剧体验。',
  },
  {
    q: '播放画质怎么样？支持高清吗？',
    a: '8090影院全站支持1080P高清播放，热门剧集更提供4K影院级画质。我们采用自研视频增强技术，在保证画质的前提下智能优化码率，即使在中低带宽环境下也能呈现清晰流畅的画面效果。',
  },
  {
    q: '更新速度跟得上吗？什么时候上新剧？',
    a: '我们建立了7×24小时内容监控体系，与各大视频平台同步追踪最新上线剧集。热门新剧通常在首播后2小时内完成更新上架，确保您第一时间就能观看到最新电视剧全集内容。',
  },
  {
    q: '为什么有时候播放会卡？怎么解决？',
    a: '播放卡顿通常与当前网络环境有关。建议您检查WiFi信号强度，或切换至4G/5G网络尝试。我们的智能加速引擎会自动适配最佳播放线路，您也可以手动在播放器中选择备用线路来获得更流畅的观影体验。',
  },
  {
    q: '支持哪些设备？可以在电视上看吗？',
    a: '8090影院全面适配手机、平板、电脑等主流设备，支持iOS、Android、Windows、Mac全平台。如需在大屏电视上观看，可通过手机投屏功能或使用浏览器直接访问，享受家庭影院般的追剧乐趣。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-question-answer-line"></i>
            帮助中心
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
          <p className="mt-2 text-foreground-500 text-sm">关于8090影院的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-4">{item.q}</h3>
                <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${
                  openIndex === idx ? 'bg-primary-500 text-white rotate-180' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}